import React from "react";
import AccessAlarmRoundedIcon from '@mui/icons-material/AccessAlarmRounded';

const HeadTagHuay = (props) => {
  return (
    <div>
      <div className="w-auto p-1 bg-[#b3853e] flex justify-between my-1">
        <div className="flex-cols px-1 py-1">
          <p className="text-sm text-[#f8eede] font-bold">{props.lotteryName} {props.round ? `รอบที่ ${props.round}` : ''} {new Date(localStorage.getItem('closeRoundDatetime')).toLocaleDateString('th-TH')}</p>
        </div>
        <div className="w-auto h-auto px-1 py-1 rounded flex text-red-600 font-bold text-sm">
          <p><AccessAlarmRoundedIcon fontSize="small"/> {props.Countdown}</p>
        </div>
      </div>
    </div>
  );
};

export default HeadTagHuay;
